import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const OtherConfigsPage = loadable(
  async () => import("~/features/other-configs/pages/OtherConfigsPage"),
  { fallback: <></> },
)

export const otherConfigRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.otherConfigs,
    element: <OtherConfigsPage />,
  },
]
